import { z } from 'zod';
import { OfferIdSchema } from './offer.js';

const LastUsedOfferDraftSchema = z
  .object({
    offerId: OfferIdSchema,
    name: z.string(),
    totalUnitCount: z.number().int().nonnegative(),
  })
  .strict();

export const LastUsedOfferDraftResponseSchema = z
  .object({
    lastUsedOfferDraft: LastUsedOfferDraftSchema.nullable(),
  })
  .strict();
export type LastUsedOfferDraftResponse = z.infer<typeof LastUsedOfferDraftResponseSchema>;

export const SetLastUsedOfferDraftBodySchema = z
  .object({
    offerId: OfferIdSchema,
  })
  .strict();
export type SetLastUsedOfferDraftBody = z.infer<typeof SetLastUsedOfferDraftBodySchema>;
